import { render, staticRenderFns } from "./BloodCountTest.vue?vue&type=template&id=d4a48b8c&scoped=true"
import script from "./BloodCountTest.vue?vue&type=script&lang=js"
export * from "./BloodCountTest.vue?vue&type=script&lang=js"
import style0 from "./BloodCountTest.vue?vue&type=style&index=0&id=d4a48b8c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a48b8c",
  null
  
)

export default component.exports